import { Descriptions } from '@surecompanies/core_components'
import React from 'react'
import type { AuditRun } from '../api/enrollment-overlap.types'
import {
  formatCount,
  formatDateScope,
  formatDateTime,
  formatDuration,
  formatTrigger,
} from '../utils/run-display'
import RunStatusTag from './RunStatusTag'

interface RunSummaryProps {
  run: AuditRun
}

/** Header facts for a run: date, trigger, scope and counts. */
export default function RunSummary({ run }: RunSummaryProps) {
  return (
    <Descriptions
      bordered
      size="small"
      column={{ xs: 1, sm: 2, lg: 3 }}
      style={{ marginBottom: 16 }}
    >
      <Descriptions.Item label="Started">
        {formatDateTime(run.startedAt)}
      </Descriptions.Item>
      <Descriptions.Item label="Status">
        <RunStatusTag run={run} />
      </Descriptions.Item>
      <Descriptions.Item label="Trigger">
        {formatTrigger(run)}
      </Descriptions.Item>
      <Descriptions.Item label="Date scope">
        {formatDateScope(run.dateScopeStart, run.dateScopeEndExclusive)}
      </Descriptions.Item>
      <Descriptions.Item label="Employees with overlaps">
        {formatCount(run.employeeCount)}
      </Descriptions.Item>
      <Descriptions.Item label="Overlapping pairs">
        {formatCount(run.pairCount)}
      </Descriptions.Item>
      <Descriptions.Item label="Duration">
        {formatDuration(run.startedAt, run.completedAt)}
      </Descriptions.Item>
    </Descriptions>
  )
}
